<template>
  <div class="row mt-2">
    <div class="col-md-4" data-v-step="3">
      <score-card-component
        title="Total Online News"
        :value_copy="data.news ? data.news.toString() : ''"
      >
        <loader-component v-if="isloading" />
        <span v-else style="color: #17a2b8">
          <i class="bi bi-globe-americas" /> {{ data.news | number_format }}
        </span>
      </score-card-component>
    </div>
    <div class="col-md-4" data-v-step="1">
      <score-card-component
        title="Total Media Cetak"
        :value_copy="data.mediacetak ? data.mediacetak.toString() : ''"
      >
        <loader-component v-if="isloading" />
        <span v-else style="color: #000000">
          <i class="bi bi-newspaper" /> {{ data.mediacetak | number_format }}
        </span>
      </score-card-component>
    </div>
    <div class="col-md-4" data-v-step="2">
      <score-card-component
        title="Total Media  TV"
        :value_copy="data.tv ? data.tv.toString() : ''"
      >
        <loader-component v-if="isloading" />
        <span v-else style="color: #28a745">
          <i class="bi bi-tv" /> {{ data.tv | number_format }}
        </span>
      </score-card-component>
    </div>
  </div>
</template>

<script>
import score_card from "@/views/components/score_card.vue";
import loader_component from "@/views/components/loader.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "medkon_score_card",
  components: {
    "loader-component": loader_component,
    "score-card-component": score_card,
  },
  props: {
    data: Object,
    isloading: Boolean,
  },
  filters: {
    number_format: function (number) {
      return gp.kmbFormatter(number);
    },
  },
};
</script>